var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62868 8.87132C4.06607 8.30871 3.75 7.54565 3.75 6.75C3.75 5.95435 4.06607 5.19129 4.62868 4.62868C5.19129 4.06607 5.95435 3.75 6.75 3.75C7.54565 3.75 8.30871 4.06607 8.87132 4.62868L19.3713 15.1287C19.9339 15.6913 20.25 16.4544 20.25 17.25C20.25 18.0456 19.9339 18.8087 19.3713 19.3713C18.8087 19.9339 18.0456 20.25 17.25 20.25C16.4544 20.25 15.6913 19.9339 15.1287 19.3713L4.62868 8.87132Z",
    stroke: "#262D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1287 4.62868C15.6913 4.06607 16.4544 3.75 17.25 3.75C17.644 3.75 18.0341 3.8276 18.398 3.97836C18.762 4.12913 19.0927 4.3501 19.3713 4.62868C19.6499 4.90726 19.8709 5.23797 20.0216 5.60195C20.1724 5.96593 20.25 6.35603 20.25 6.75C20.25 7.14397 20.1724 7.53407 20.0216 7.89805C19.8709 8.26203 19.6499 8.59275 19.3713 8.87132L8.87132 19.3713C8.59275 19.6499 8.26203 19.8709 7.89805 20.0216C7.53407 20.1724 7.14397 20.25 6.75 20.25C6.35603 20.25 5.96593 20.1724 5.60195 20.0216C5.23797 19.8709 4.90726 19.6499 4.62868 19.3713C4.06607 18.8087 3.75 18.0456 3.75 17.25C3.75 16.4544 4.06607 15.6913 4.62868 15.1287L15.1287 4.62868Z",
    stroke: "#262D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.125C12.6213 13.125 13.125 12.6213 13.125 12C13.125 11.3787 12.6213 10.875 12 10.875C11.3787 10.875 10.875 11.3787 10.875 12C10.875 12.6213 11.3787 13.125 12 13.125Z",
    fill: "#262D38"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboards);
export default __webpack_public_path__ + "static/media/Dashboards.f77ffe2b3689f4a9a38bde7018971b18.svg";
export { ForwardRef as ReactComponent };